import { CircularProgressProps, } from '@material-ui/core/CircularProgress/CircularProgress';
import React, { memo, ReactNode, } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

interface UnknownProgressLoaderProps extends Pick<CircularProgressProps, 'size'> {
	theme?: 'curiousblue' | 'alabaster';
	children?: ReactNode;
}

export default memo( function UnknownProgressLoaderComponent( props: UnknownProgressLoaderProps ) {
	const {
		children,
		theme = 'curiousblue',
		size = 128,
	} = props;

	return <section className={`h-full w-full flex flex-col justify-center items-center text-${theme}`}>
		<CircularProgress variant="indeterminate" color="inherit" size={size}/>
		{children}
	</section>;
} );
